import ServiceAPI from "./serviceapi";
import CacheService from "./CacheService";

const CONFIG_TTL_MS = 10 * 60 * 1000; // 10 min
const CACHE_PREFIX = "configusuario:";

function buildCacheKey(chave: string, tipo: string): string {
  return `${CACHE_PREFIX}${tipo}:${chave}`;
}

export async function carregarConfig(chave: string, tipo: string): Promise<any> {
  return CacheService.fetch(
    buildCacheKey(chave, tipo),
    async () => {
      const config = {
        url: "/configusuario/carregar",
        data: { chave, tipo },
        config: { ignoreToast: true },
      };
      const res = await ServiceAPI.execNativeService(config);
      const raw = res?.dataResponse?.valor;
      if (!raw) return null;
      try { return JSON.parse(raw); } catch { return raw; }
    },
    CONFIG_TTL_MS
  );
}

export async function salvarConfig(
  chave: string,
  tipo: string,
  valor: string
): Promise<any> {
  const config = {
    url: "/configusuario/salvar",
    data: { chave, tipo, valor },
    config: { ignoreToast: true },
  };

  const res = await ServiceAPI.execNativeService(config);
  const valorSalvo = res?.dataResponse?.valor
    ? JSON.parse(res.dataResponse.valor)
    : null;

  // Write-through: atualiza o cache imediatamente após salvar
  const cacheKey = buildCacheKey(chave, tipo);
  if (valorSalvo !== null) {
    CacheService.set(cacheKey, valorSalvo, CONFIG_TTL_MS);
  } else {
    CacheService.invalidate(cacheKey);
  }

  return valorSalvo;
}

export function invalidarConfig(chave: string, tipo: string): void {
  CacheService.invalidate(buildCacheKey(chave, tipo));
}

export function invalidarTodasConfigs(): void {
  CacheService.invalidateByPrefix(CACHE_PREFIX);
}